<template>
  <div class="contain_test">
    <div class="contain_test_top">
      <h3>直播设备检测</h3>
      <div class="el-icon-close"></div>
    </div>
    <div class="contain_test_content">
      <div class="left">
        <video ref="video" width="481" height="270" autoplay></video>
      </div>
      <div class="right">
        <div class="camera">
          <h4>摄像头</h4>
          <el-select v-model="valueOne" placeholder="请选择" @change="handleVideo">
            <el-option
              v-for="(item,index) in videoData"
              :key="index"
              :label="item.label"
              :value="item.deviceId"
            ></el-option>
          </el-select>
        </div>
        <div class="microphone">
          <h4>麦克风</h4>
          <el-select v-model="valueTwo" placeholder="请选择">
            <el-option
              v-for="(item,index) in audioInputData"
              :key="index"
              :label="item.label"
              :value="item.deviceId"
            ></el-option>
          </el-select>
        </div>
        <div class="loudspeaker">
          <h4>扬声器</h4>
          <el-select v-model="valueTwo" placeholder="请选择">
            <el-option
              v-for="(item,index) in audioOutputData"
              :key="index"
              :label="item.label"
              :value="item.deviceId"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="contain_test_btn">确认</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      optionOne: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      optionTwo: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      valueOne: "",
      valueTwo: "",
      videoData: [], //摄像头数据
      audioInputData: [], // 音频输入设备
      audioOutputData: [] //音频输出设备
    };
  },
  mounted() {
    let opt = {
      audio: true,
      video: true
    };
    if (navigator.mediaDevices.getUserMedia) {
      navigator.mediaDevices
        .getUserMedia(opt)
        .then(mediaStream => {
          console.log(mediaStream);
          let CompatibleURL = window.URL || window.webkitURL;

          this.$refs.video.srcObject = mediaStream;
          // video.onloadedmetadata = function (e) {
          this.$refs.video.play();
          // };
        })
        .catch(function(err) {
          console.log(err.name + ": " + err.message);
        }); // always check for errors at the end.}
    }
    this.getEquipmentData();
  },
  methods: {
    // 获取设备
    getEquipmentData() {
      //首次运行引导用户，信任域名
      var first = window.localStorage.getItem("first");
      if (first == null) {
        if (
          navigator.mediaDevices.getUserMedia ||
          navigator.getUserMedia ||
          navigator.webkitGetUserMedia ||
          navigator.mozGetUserMedia
        ) {
          //调用用户媒体设备, 访问摄像头
          this.getUserMedia(
            { video: { width: 482, height: 271 } },
            this.getUserMediaSuccess,
            this.getUserMediaError
          );
        } else {
          alert("不支持访问用户媒体");
        }
      }
      if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("menumerateDevices is not supported!");
      } else {
        navigator.mediaDevices
          .enumerateDevices()
          .then(this.gotDevices)
          .catch(error => {
            console.log("Error: ", error);
          });
      }
    },
    // 区别设备
    gotDevices(deviceInfos) {
      console.log(deviceInfos);
      deviceInfos.forEach(item => {
        if (item.kind == "audioinput") {
          this.audioInputData.push(item);
        } else if (item.kind == "videoinput") {
          this.videoData.push(item);
        } else if (item.kind == "audiooutput") {
          this.audioOutputData.push(item);
        }
      });
      console.log(this.audioInputData, this.videoData, this.audioOutputData);
    },
    //访问用户媒体设备的兼容方法
    getUserMedia(constraints, success, error) {
      if (navigator.mediaDevices.getUserMedia) {
        //最新的标准API
        navigator.mediaDevices
          .getUserMedia(constraints)
          .then(success)
          .catch(error);
      } else if (navigator.webkitGetUserMedia) {
        //webkit核心浏览器
        navigator.webkitGetUserMedia(constraints, success, error);
      } else if (navigator.mozGetUserMedia) {
        //firfox浏览器
        navigator.mozGetUserMedia(constraints, success, error);
      } else if (navigator.getUserMedia) {
        //旧版API
        navigator.getUserMedia(constraints, success, error);
      }
    },
    // 成功
    getUserMediaSuccess(stream) {
      console.log(stream);
      window.localStorage.setItem("first", "false");
      // window.location.reload();
    },
    // 失败
    getUserMediaError(error) {
      console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
    },
    // 摄像头选择
    handleVideo(e) {
      console.log(123, e);
      const videoConstraints = {};
      if (e === "") {
        videoConstraints.facingMode = "environment";
      } else {
        videoConstraints.deviceId = { exact: e };
      }
      const constraints = {
        video: videoConstraints,
        audio: true
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(stream => {
          console.log(123, stream);
          // currentStream = stream;
          this.$refs.video.srcObject = stream;
          // return navigator.mediaDevices.enumerateDevices();
          console.log(navigator.mediaDevices.enumerateDevices());
        })
        .catch(error => {
          console.error(error);
        });
    }
  }
};
</script>

<style scoped lang="scss">
.contain_test {
  width: 830px;
  height: 471px;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  background-color: #fff;
  padding-top: 27px;
  box-sizing: border-box;
  text-align: left;
  .contain_test_top {
    padding-left: 38px;
    position: relative;
    margin-bottom: 47px;
    h3 {
      font-size: 16px;
      font-weight: 500;
      color: #323643;
    }
    div {
      position: absolute;
      top: 0;
      right: 37px;
      font-weight: 700;
      font-size: 18px;
      color: #979797;
    }
  }
  .contain_test_content {
    display: flex;
    align-items: center;
    margin-left: 44px;
    margin-bottom: 35px;
    .left {
      width: 482px;
      height: 271px;
      border: 1px solid #ebebeb;
      box-sizing: border-box;
      margin-right: 20px;
    }
    .right {
      div h4 {
        font-size: 16px;
        font-weight: 400;
        text-align: left;
        color: #585b63;
        margin-bottom: 8px;
      }
      .camera {
        margin-bottom: 20px;
      }
      .microphone {
        margin-bottom: 20px;
      }
    }
    div ::v-deep .el-select .el-input.is-focus .el-input__inner:focus {
      border-color: #07d1aa;
    }
    div ::v-deep .el-select .el-input__inner:focus {
      border-color: #07d1aa;
    }

    div ::v-deep .el-select .el-input.is-focus .el-input__inner {
      border-color: #07d1aa;
    }
  }
  .contain_test_btn {
    text-align: center;
    width: 165px;
    height: 35px;
    line-height: 35px;
    background: #07d1aa;
    border-radius: 4px;
    font-size: 16px;
    color: #ffffff;
    margin: 0 auto;
    cursor: pointer;
  }
}
.el-select-dropdown .el-scrollbar .selected {
  color: #07d1aa;
}
</style>